import { createSlice } from "@reduxjs/toolkit";

const loadCart = () => {
  try {
    return JSON.parse(localStorage.getItem("cart")) || [];
  } catch {
    return [];
  }
};

const saveCart = (cartItems) => {
  localStorage.setItem("cart", JSON.stringify(cartItems));
};

const getCount = (items) => {
  return items.reduce((total, item) => total + (Number(item.qty) || 0), 0);
};

const cartItems = loadCart();

const initialState = {
  cartItems,
  cartCount: getCount(cartItems),
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;

      const exist = state.cartItems.find(
        (item) => item.product_id === product.product_id
      );

      if (exist) {
        exist.qty += Number(product.qty) || 1;
      } else {
        state.cartItems.push({
          ...product,
          qty: Number(product.qty) || 1,
        });
      }

      state.cartCount = getCount(state.cartItems);
      saveCart(state.cartItems);
    },

    removeCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.product_id !== action.payload
      );

      state.cartCount = getCount(state.cartItems);
      saveCart(state.cartItems);
    },

    clearCart: (state) => {
      state.cartItems = [];
      state.cartCount = 0;
      saveCart([]);
    },

    setCartCount: (state, action) => {
      state.cartCount = Number(action.payload) || 0;
    },
  },
});

export const {
  addToCart,
  removeCart,
  clearCart,
  setCartCount,
} = cartSlice.actions;

export default cartSlice.reducer;